import { Component, OnInit } from '@angular/core';
import { QaReportService } from './services/qa-report.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-qa-report-dashboard',
  templateUrl: './qa-report-dashboard.component.html',
  styleUrls: ['./qa-report-dashboard.component.scss']
})
export class QAReportDashboardComponent implements OnInit {
  accessRoles: any;
  constructor(public qaService:QaReportService, public sidePanelService:SidePanelService) { 
    this.sidePanelService.initSideDrawer('qa-report');
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }

  ngOnInit(): void {
    this.qaService.setQaReportConfig();
  }

}
